import { CustomerPhoneForm } from '@/@types/customer';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { TableActions } from '@/components/common/Table/TableActions';

export const CustomerPhonesTableColumns: ColumnDefinitionType<CustomerPhoneForm>[] =
  [
    {
      key: 'phone',
      header: 'Telefone',
      sort: '',
      render: (phone) => phone?.phone || '',
    },
    {
      key: 'customerId',
      header: 'Ações',
      sort: '',
      render: (phone) => (
        <TableActions
          id={phone.phone}
          editButtonPermission="customers_update"
          deleteButtonPermission="customers_update"
          restoreButtonPermission="customers_update"
          onEdit={() => phone.onEditPhone(phone)}
          onDelete={() => phone.onRemovePhone(phone.id as number)}
        />
      ),
    },
  ];
